const timezones = {
    utc: 'UTC',
    americaNewYork: 'America/New_York',
    americaChicago: 'America/Chicago',
    americaLosAngeles: 'America/Los_Angeles',
    europeLondon: 'Europe/London',
    europeBerlin: 'Europe/Berlin',
    asiaTokyo: 'Asia/Tokyo',
    australiaSydney: 'Australia/Sydney',
  } as const;

export default timezones;
